module.exports = __webpack_public_path__ + "img/yoututor_1.ecfbd6ba.jpg";